const getPlainPath = (path: string) => {
  let plainPath = path.replace(/\/[a-z]{2,3}-[A-Z]{2}\//, '/');

  if (!plainPath.endsWith('/')) {
    plainPath += '/';
  }

  return plainPath;
}

const isLending = (path: string) => {
  return path === '/trade/spot/lending/guide/';
}


export const getNativePath =(
  to: string
): { path: string; topPage: boolean } | void => {
  const prefix = 'bybitapp://open';
  const url = new URL(to, window.location.href);
  const path = getPlainPath(url.pathname);

  // lending H5
  if (isLending(path)) {
    return { path: `${prefix}/spot/lending/home`, topPage: false };
  }

}
